module.exports = __webpack_public_path__ + "img/illu-card-beschwerden-fever.81379d76.svg";